/*******************************************************************
* PAGE        : ButtonComponent
* REMARKS     : Comman Button Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 31-03-2026
********************************************************************/

import './ButtonComponent.css';

const ButtonComponent = ({
    color = 'primary',
    hoverColor,
    icon,
    iconPosition = 'left',
    rounded = false,
    children,
    size = '',
    disabled = false,
    style = {},
    ...props
}) => {
    const buttonWidth = size === 'full' ? '100%' : size === 'half' ? '50%' : size === 'small' ? '120px' : '';
    return (
        <button
            className={`custom-button ${color} ${rounded ? 'rounded' : ''}`}
            {...props}
            style={{ width: buttonWidth }}
            disabled={disabled}
        >
            {icon && iconPosition === 'left' && <img src={icon} className='custom-button-left-icon' />}
            {children}
            {icon && iconPosition === 'right' && <img src={icon} className='custom-button-right-icon' />}
        </button>
    );
};

export default ButtonComponent;
